const seriesOptions = {
  getScatter: (options) => ({
    ...options,
    id: options.id || `scatter-${new Date().getTime()}`,
    type: 'scatter',
    states: {
      hover: {
        enabled: false,
      },
    },
    zIndex: 10,
  }),
  getSMA: (options) => ({
    id: options.id || `sma-${options.linkedTo || 'main'}-${options.period}`,
    type: 'sma',
    linkedTo: options.linkedTo || 'main',
    lineWidth: options.lineWidth || 2,
    dashStyle: options.dashStyle,
    params: {
      index: 3,
      period: options.period,
    },
    color: options.color,
    marker: {
      enabled: false,
      states: {
        hover: {
          enabled: false,
        },
      },
    },
    visible: options.visible !== false,
  }),
  getVSMA: (options) => ({
    id: options.id || `vsma-${options.linkedTo || 'volume'}-${options.period}`,
    type: 'sma',
    linkedTo: options.linkedTo || 'volume',
    lineWidth: options.lineWidth || 2,
    dashStyle: options.dashStyle,
    yAxis: 'volume-yaxis',
    params: {
      index: 3,
      period: options.period,
    },
    color: options.color,
    marker: {
      enabled: false,
      states: {
        hover: {
          enabled: false,
        },
      },
    },
    visible: options.visible !== false,
  }),
}

export default seriesOptions
